import { jsx, jsxs } from "react/jsx-runtime";
import { formatVoiceSegmentStartTime, formatVoiceSegmentDuration } from "./voiceSegments.js";
import { VoiceThemeProvider } from "../voice/theme/VoiceThemeProvider.js";
const PhoneIconGlyph = () => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    children: /* @__PURE__ */ jsx("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2z" })
  }
);
const ChevronGlyph = ({ open }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { transform: open ? "rotate(0deg)" : "rotate(-90deg)", transition: "transform 120ms ease" },
    "aria-hidden": "true",
    children: /* @__PURE__ */ jsx("polyline", { points: "6 9 12 15 18 9" })
  }
);
const VoiceSegmentSeparatorCard = ({
  durationSec,
  turnCount,
  tWallStartIso,
  messageCount,
  expanded,
  onToggle
}) => {
  const durationLabel = formatVoiceSegmentDuration(durationSec);
  const startLabel = formatVoiceSegmentStartTime(tWallStartIso);
  const turnLabel = `${turnCount} ${turnCount === 1 ? "turn" : "turns"}`;
  const discloseLabel = expanded ? `Hide ${messageCount} ${messageCount === 1 ? "message" : "messages"}` : `Show ${messageCount} ${messageCount === 1 ? "message" : "messages"}`;
  return /* @__PURE__ */ jsx(VoiceThemeProvider, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: "voice-segment-separator-card",
      role: "separator",
      "aria-label": `Voice call segment: ${durationLabel}, ${turnLabel}`,
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6,
        padding: "10px 14px",
        border: "1px solid var(--voice-widget-border, #E5E7EB)",
        borderRadius: 12,
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        color: "var(--voice-widget-fg, #111827)",
        fontSize: 13,
        lineHeight: 1.4,
        width: "100%",
        boxSizing: "border-box"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12
            },
            children: [
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 8, minWidth: 0, flex: 1 }, children: [
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    style: {
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: "var(--voice-widget-img-bg, #F9FAFB)",
                      color: "var(--voice-widget-accent-dark, #0D9488)",
                      flexShrink: 0
                    },
                    children: /* @__PURE__ */ jsx(PhoneIconGlyph, {})
                  }
                ),
                /* @__PURE__ */ jsxs(
                  "span",
                  {
                    style: {
                      fontWeight: 600,
                      color: "var(--voice-widget-fg, #111827)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    },
                    children: [
                      "Voice call",
                      /* @__PURE__ */ jsxs("span", { style: { color: "var(--voice-widget-muted, #6B7280)", fontWeight: 500 }, children: [
                        " · ",
                        durationLabel,
                        " · ",
                        turnLabel
                      ] })
                    ]
                  }
                )
              ] }),
              startLabel ? /* @__PURE__ */ jsx(
                "span",
                {
                  style: {
                    color: "var(--voice-widget-muted, #6B7280)",
                    fontSize: 12,
                    whiteSpace: "nowrap",
                    flexShrink: 0
                  },
                  children: startLabel
                }
              ) : null
            ]
          }
        ),
        messageCount > 0 ? /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            onClick: onToggle,
            "aria-expanded": expanded,
            style: {
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 8px",
              alignSelf: "flex-start",
              background: "transparent",
              border: "1px solid var(--voice-widget-border, #E5E7EB)",
              borderRadius: 999,
              color: "var(--voice-widget-muted, #6B7280)",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer"
            },
            children: [
              /* @__PURE__ */ jsx(ChevronGlyph, { open: expanded }),
              discloseLabel
            ]
          }
        ) : null
      ]
    }
  ) });
};
export {
  VoiceSegmentSeparatorCard
};
//# sourceMappingURL=VoiceSegmentSeparatorCard.js.map
